import React, { useState, useEffect } from 'react';
import './actors.css';
import { Card, CardMedia, CardContent, Typography, Box, Tooltip } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import ActorModal from './Modal';
import LoginAlert from './LoginAlert';
import LoginPopup from '../auth/LoginPopup';

import UnknownProfileImage from '../../assets/profile.jpg';
import Slider from 'react-slick';

const ActorCard = ({ actor, ratings, userRole, role, selectedCrewIds, handleCrewSelectionChange }) => { // Added selectedCrewIds and handleCrewSelectionChange
  const actorId = actor.user.id;
  const sliderRef = React.useRef(null);

  const imageURL =
    actor?.user?.imageURL || actor?.profile?.imageURL || UnknownProfileImage;

  const getImagesArray = () => {
    try {
      if (
        actor?.user?.images &&
        Array.isArray(actor.user.images) &&
        actor.user.images.length > 0
      ) {
        return actor.user.images;
      }

      if (actor?.user?.images && typeof actor.user.images === 'string') {
        try {
          const parsed = JSON.parse(actor.user.images);
          if (Array.isArray(parsed) && parsed.length > 0) {
            return parsed;
          }
        } catch (e) { }
      }

      if (
        actor?.user?.images &&
        typeof actor.user.images === 'string' &&
        !actor.user.images.startsWith('[')
      ) {
        return [actor.user.images];
      }

      const fallbackImage =
        actor?.user?.imageURL ||
        actor?.profile?.imageURL ||
        UnknownProfileImage;
      return [fallbackImage];
    } catch (error) {
      return [UnknownProfileImage];
    }
  };

  const imagesArray = getImagesArray();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (sliderRef.current) {
        sliderRef.current.slickGoTo(0);
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [imagesArray]);

  const rate = actor?.user?.rate || actor?.profile?.rate || 0;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoginAlertOpen, setIsLoginAlertOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  // Derive isSelected from selectedCrewIds prop
  const isSelected = selectedCrewIds.includes(actorId);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const closeLoginAlert = () => setIsLoginAlertOpen(false);

  const handleContactActor = () => {
    closeModal();
    setIsLoginAlertOpen(true);
  };

  const handleClickLogin = () => {
    setIsLoginOpen(true);
    closeLoginAlert();
  };

  // Remove useEffect for localStorage and toggleSelection directly updates parent state
  const toggleSelection = (e) => {
    handleCrewSelectionChange(actorId, e.target.checked);
  };
  const subscriptionExpire = actor.user?.subscriptionExpire;

  return (
    <>
      <div className='relative' style={{ position: 'relative' }}>
        {(userRole === 'producer' || userRole === 'director') && (
              <input
                type="checkbox"
                className="select-checkbox"
                // checked={subscriptionExpire ? false : isSelected}
                checked={ isSelected}
                onChange={toggleSelection}
                // disabled={subscriptionExpire}
              /> 
        )}
        <Card
          sx={{
            position: 'relative',
            // width: 180,
            height: 250,
            borderRadius: 1,
            overflow: 'hidden',
            boxShadow: 3,
            cursor: 'pointer',
            '&:hover': {
              transform: 'scale(1.005)',
              transition: '0.3s ease-in-out',
            },
          }}
          onClick={openModal}
        >
          {/* {userRole === 'producer' || userRole === 'director' ? (
            <div className={`actor-card ${isSelected ? 'selected' : ''}`}>
              <Box sx={{ height: '250px', position: 'relative' }}>
                <Slider
                  dots={false}
                  infinite={true}
                  speed={500}
                  slidesToShow={1}
                  slidesToScroll={1}
                  autoplay={true}
                  autoplaySpeed={3000}
                  style={{
                    overflow: 'hidden',
                  }}
                >
                  {imagesArray?.length > 0 ? (
                    imagesArray?.map((image, index) => (
                      <div
                        key={index}
                        style={{ height: '250px', width: '100%' }}
                      >
                        <CardMedia
                          component='img'
                          height='250px'
                          image={image || UnknownProfileImage}
                          alt={actor.user?.firstName || 'Unknown'}
                          sx={{ objectFit: 'cover' }}
                          onError={(e) => {
                            e.target.src = UnknownProfileImage;
                          }}
                        />
                      </div>
                    ))
                  ) : (
                    <div style={{ height: '250px', width: '100%' }}>
                      <CardMedia
                        component='img'
                        height='250px'
                        image={UnknownProfileImage}
                        alt='Unknown'
                        sx={{
                          objectFit: 'cover',
                          width: '100%',
                          height: '100%',
                        }}
                      />
                    </div>
                  )}
                </Slider>
              </Box>
            </div>
          ) : (
            <Box sx={{ height: '250px', position: 'relative' }}>
              {imagesArray?.length > 0 && (
                <Slider
                  ref={sliderRef}
                  dots={false}
                  infinite={imagesArray.length > 1}
                  speed={500}
                  slidesToShow={1}
                  slidesToScroll={1}
                  autoplay={imagesArray.length > 1}
                  autoplaySpeed={3000}
                  lazyLoad='ondemand'
                  style={{
                    overflow: 'hidden',
                    height: '250px',
                    width: '100%',
                  }}
                >
                  {imagesArray.map((image, index) => (
                    <div
                      key={index}
                      style={{
                        height: '250px',
                        width: '100%',
                        position: 'relative',
                        overflow: 'hidden',
                      }}
                    >
                      <CardMedia
                        component='img'
                        height='250px'
                        image={image || UnknownProfileImage}
                        alt={actor.user?.firstName || 'Unknown'}
                        sx={{ objectFit: 'cover' }}
                        onError={(e) => {
                          e.target.src = UnknownProfileImage;
                        }}
                      />
                    </div>
                  ))}
                </Slider>
              )}
              {(!imagesArray || imagesArray.length === 0) && (
                <div style={{ height: '250px', width: '100%' }}>
                  <img
                    src={UnknownProfileImage}
                    alt='Unknown'
                    style={{
                      objectFit: 'cover',
                      width: '100%',
                      height: '100%',
                      display: 'block',
                    }}
                  />
                </div>
              )}
            </Box>
          )} */}
          {userRole === 'producer' || userRole === 'director' ? (
            <div className={`actor-card ${isSelected ? 'selected' : ''}`}>
              <CardMedia
                component='img'
                height='100%'
                image={imageURL}
                alt={actor.user?.firstName || 'Unknown'}
                sx={{ objectFit: 'cover' }}
              />
            </div>
          ) : (
            <CardMedia
              component='img'
              height='100%'
              image={imageURL}
              alt={actor.user?.firstName || 'Unknown'}
              sx={{ objectFit: 'cover' }}
            />
          )}

          <CardContent
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
              padding: '10px',
              color: 'white',
              background:
                'linear-gradient(to top, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0))',
            }}
          >
            <Typography
              variant='h6'
              sx={{ fontWeight: 'bold', fontSize: '16px' }}
            >
              {actor.user.firstName.charAt(0).toUpperCase() +
                actor.user.firstName.slice(1)}
            </Typography>
          </CardContent>

          <ActorModal
            actor={actor}
            closeModal={closeModal}
            contactActor={handleContactActor}
            isModalOpen={isModalOpen}
            role={role}
            setIsModalOpen={setIsModalOpen}
          />
          <LoginAlert
            isLoginAlertOpen={isLoginAlertOpen}
            closeAlert={closeLoginAlert}
            handleClickLogin={handleClickLogin}
          />
          <LoginPopup
            isLoginOpen={isLoginOpen}
            setIsLoginOpen={setIsLoginOpen}
          />
        </Card>
      </div>
    </>
  );
};

export default ActorCard;
